import React, { Component } from 'react';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import * as  RefLinkMaintenanceAction from '../actions/RefSiteMaintenanceAction';
import RefLinkMaintenanceStore from '../stores/RefSiteMaintenanceStore';
import { withTranslation, Trans } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import * as MenuAction from '../actions/MenuAction';
import swal from 'sweetalert';

let currentPagePath;
class RefSiteMaintenanceComponent extends Component {

    /**
        * Set the initial values of the state variables
            */
    constructor(props) {

        super(props);
        /** Set the initial values of the state variables
            */
        this.state = {
            GridArray: [],
            SiteName: "",
            SiteURL: "",
            BusinessUnit: "",
            IsEditClicked: false,
            IsNewLink: false,
            NewSiteName: "",
            NewSiteURL: "",
            BusinessUnit: "",
            pageCount: "1",
            pageNo: "1",
            isFavorited: false,
            AddNewURL: "",
            EditIndex: "",
            IsEditOrDelete: "",
            //[12/1/22], Bug - 2909, Dhevanesam R
            IsEditSiteName: false,
            IsEditSiteURL: false
        }
    }
    /***
     * REFLINK_PC_02 - PAVITHRA R , DHAMOTHARAN P
     * */


    componentDidMount() {
        
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        this.PageLoad()
        RefLinkMaintenanceStore.on("RefSiteMaintenancePageLoad", this.PageloadResponse);
        RefLinkMaintenanceStore.on("RefSiteMaintenanceUpdate", this.EditOrDeleteResponse);
        RefLinkMaintenanceStore.on("AddRefSiteMaintenance", this.AddNewURLResponse);
        RefLinkMaintenanceStore.on("favpage", this.loadFavPageResponse.bind(this));
        RefLinkMaintenanceStore.on("updateFavPage", this.updateFavPageResponse.bind(this));
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        RefLinkMaintenanceAction.getCurrentFavPage(getFavPageBO);
    };
    /***
     * REFLINK_PC_03 - PAVITHRA R , DHAMOTHARAN P
     * */
    PageLoad() {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let BusUnit = CookieService.getLocalStorageValues("Session_BUSUNIT");
        RefLinkMaintenanceAction.PageLoad(BusUnit);


    };
    /***
     * REFLINK_PC_08 - PAVITHRA R , DHAMOTHARAN P
     * */

    PageloadResponse = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let PageLoadResponse = JSON.parse(RefLinkMaintenanceStore.PageLoadData);
        if (PageLoadResponse != undefined && PageLoadResponse != null && PageLoadResponse != "") {
            if (PageLoadResponse.length > 0) {
                let Griddata = PageLoadResponse;
                for (let value of Griddata) {
                    value.IsEditClicked = false;
                    value.EditSiteName = value.SITE_DESC;
                    value.EditSiteURL = value.SITE_URL;
                }
                this.setState({ GridArray: Griddata, pageCount: (Griddata.length) / 10, pageNo: "1" });
            };
        }

    }
    /***
     * REFLINK_PC_08 - PAVITHRA R , DHAMOTHARAN P
     * */

    EditOrDeleteResponse = () => {
        

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let UpdateData = JSON.parse(RefLinkMaintenanceStore.UpdateResponse);
        //alert(UpdateData);
        let GridData = this.state.GridArray;
        //window.location.reload();
        if (this.state.IsEditOrDelete == "Edit") {
            if (UpdateData.toLowerCase() == "reference site updated successfully") {
                let EditIndex = this.state.EditIndex;
                GridData.map((val, index) => {
                    if (index == EditIndex) {
                        let EditedSitename = GridData[index].EditSiteName;
                        let EditedSiteurl = GridData[index].EditSiteURL;
                        val.EditSiteName = EditedSitename;
                        val.EditSiteURL = EditedSiteurl;
                        val.SITE_DESC = EditedSitename;
                        val.SITE_URL = EditedSiteurl;
                        val.IsEditClicked = false;

                    }
                });
                //[12/1/22], Bug - 2909, Dhevanesam R
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: UpdateData
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: UpdateData
                });
            }
            this.setState({ IsEditSiteName: false, IsEditSiteURL: false })
        }
        else {
            let EditIndex = this.state.EditIndex;
            //A1QA-112_PC_01 -(1/3/2023)-Aparna
            if (UpdateData.toLowerCase() == "reference site deleted successfully") {
                GridData.splice(EditIndex, 1)
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: UpdateData
                });
            }
            //else {
            //    swal({
            //        allowOutsideClick: false,
            //        closeOnClickOutside: false,
            //        text: UpdateData
            //    });
            //    //alert(UpdateData);
            //}
        }
        this.PageLoad()
        this.setState({ GridArray: GridData});
    }
    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ pageNo: pageNo });
    }
    /***
     * REFLINK_PC_16 - PAVITHRA R , DHAMOTHARAN P
     * */

    AddNewURLResponse = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let AddNewResponse = RefLinkMaintenanceStore.AddNewResponse;
        //console.log("add new alert", AddNewResponse)
        swal(AddNewResponse);
        //window.location.reload();
        let localArray = [];
        let obj = {
            BUSINESS_UNIT: "I0W01",
            EditSiteName: this.state.NewSiteName,
            EditSiteURL: this.state.NewSiteURL,
            ISDELETE: "N",
            IsEditClicked: false,
            SITE_DESC: this.state.NewSiteName,
            SITE_URL: this.state.NewSiteURL,
        }
        localArray.push(obj)
        for (let value of this.state.GridArray) {
            localArray.push(value)
        }
        this.setState({ GridArray: localArray, IsNewLink: false, pageCount: (localArray.length) / 10 })


    }


    onCancelClick = (e, index) => {
        let { GridArray } = this.state;
        this.state.GridArray[index].IsEditClicked = false;
        //A1QA-112 BUG (1/3/2023)-Aparna
        this.state.GridArray[index].EditSiteName = this.state.GridArray[index].SITE_DESC;
        this.state.GridArray[index].EditSiteURL = this.state.GridArray[index].SITE_URL;
        this.setState({ GridArray: GridArray })
    };

    onNewCancelClick = (e) => {

        this.setState({ IsNewLink: false });

    };
    /***
     * REFLINK_PC_10 - PAVITHRA R , DHAMOTHARAN P
     * */

    onEditClick = (e, index) => {
        let { GridArray } = this.state;
        this.state.GridArray[index].IsEditClicked = true;
        this.setState({ GridArray: GridArray })
    }
    OnHandleEditChange = (e, type, index) => {
        //[12/1/22], Bug - 2909, Dhevanesam R
        let { GridArray } = this.state;
        let IsEditSiteNameVal = false
        let IsEditSiteURLVal = false

        if (type == "EditSiteName") {
            GridArray[index].EditSiteName = e.target.value;
            IsEditSiteNameVal = true;
            this.setState({ IsEditSiteName: IsEditSiteNameVal })
        }
        else if (type == "EditSiteURL") {
            GridArray[index].EditSiteURL = e.target.value;
            IsEditSiteURLVal = true
            this.setState({ IsEditSiteURL: IsEditSiteURLVal })
        }

        this.setState({ GridArray: GridArray })
    };
    /***
     * REFLINK_PC_17 - PAVITHRA R , DHAMOTHARAN P
     * */

    onDeleteClick = (e, index) => {

        let { GridArray } = this.state;
        this.setState({ IsEditOrDelete: "Delete", EditIndex: index })
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let UpdateDataBO = {
            ExistingSiteName: GridArray[index].SITE_DESC,
            ExistingSiteURL: GridArray[index].SITE_URL,

        }
        RefLinkMaintenanceAction.UpdateChanges(UpdateDataBO);
    }
    /***
     * REFLINK_PC_12 - PAVITHRA R , DHAMOTHARAN P
     * */
    OnNewURLClick = (e) => {
        this.setState({
            IsNewLink: true, NewSiteName: "", NewSiteURL: "",
        });
    };

    OnHandleNewChange = (e, type) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    OnInsertClick = (e) => {

        
        let IsURLExists = false;
        //[10/14/22, Bug - 2575 - To restrict to add or update the same reference site name , Dhevanesam R]
        let IsSiteNameExist = false;

        for (let value of this.state.GridArray) {

            if (value.SITE_URL == this.state.NewSiteURL) {
                IsURLExists = true;

            }
            if (value.SITE_DESC != null && this.state.NewSiteName != null) {
                if (value.SITE_DESC.toUpperCase().trim() == this.state.NewSiteName.toUpperCase().trim()) {
                    IsSiteNameExist = true;
                }
            }
        }
        //[12/2/22], Bug - 2959 - To remove space, Dhevanesam R
        if (this.state.NewSiteName.trim() == "" && this.state.NewSiteURL.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter Site Name and Site URL"
            });
            //  alert("Please enter Site Name,Site URL and BusinessUnit");
        }
        else if (this.state.NewSiteName.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter Site Name"
            });
            //  alert("Please enter Site Name");
        }
        else if (this.state.NewSiteURL.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter Site URL"
            });
            // alert("Please enter Site URL");
        }
        else if (IsURLExists == true) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Reference site already exists"
            });
            //alert("Reference site already exists");
        }
        else if (IsSiteNameExist == true) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Reference site name already exists"
            });
            // alert("Reference site already exists");
        }
        else if (this.state.NewSiteURL != "") {
            let urlstr = this.state.NewSiteURL;
            let rex = SDIConstants.urlregexp;
            if (!rex.test(urlstr)) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter valid Site URL"
                });
                //alert("Please enter valid Site URL");
            }
            else {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                let AddNewURLBO = {
                    IsNewLink: true,
                    SiteName: this.state.NewSiteName.trim(),
                    SiteURL: this.state.NewSiteURL,
                    BusUnit: this.state.BusinessUnit,

                    IsDelete: "N"
                }
                RefLinkMaintenanceAction.AddNewURL(AddNewURLBO);
            }

        }



    }
    /***
     * REFLINK_PC_12 - PAVITHRA R , DHAMOTHARAN P
     * */

    OnSaveClick = (e, index) => {
        
        //[12/1/22], Bug - 2909, Dhevanesam R
        let { GridArray } = this.state;
        // A1QA-112 BUG (1/4/2023)-Aparna
        let IsURLExists = false;
        let IsSiteNameExist = false;

        GridArray.forEach((value, ind) => {
            if (ind != index) {
                if (GridArray[index].EditSiteURL != "" && GridArray[index].EditSiteURL != null && GridArray[index].EditSiteURL != undefined) {
                    if (value.SITE_URL == GridArray[index].EditSiteURL) {
                        IsURLExists = true;

                    }
                }
                if (GridArray[index].EditSiteName != null && GridArray[index].EditSiteName != undefined) {
                    if (value.SITE_DESC.toUpperCase().trim() == GridArray[index].EditSiteName.toUpperCase().trim()) {
                        IsSiteNameExist = true;
                    }
                }
            }
        })

        this.setState({ EditIndex: index, IsEditOrDelete: "Edit" });
        if (GridArray[index].EditSiteName.trim() == "" && GridArray[index].EditSiteURL.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter Site Name and Site URL"
            });
            //   alert("Please enter Site Name and Site URL");
        }
        else if (GridArray[index].EditSiteName.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter Site Name"
            });
            //  alert("Please enter Site Name");
        }
        else if (GridArray[index].EditSiteURL.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter Site URL"
            });
            //  alert("Please enter Site URL");
        }

        else if (GridArray[index].EditSiteURL.trim() != "") {
            let urlstr = GridArray[index].EditSiteURL;
            let rex = SDIConstants.urlregexp;
            if (!rex.test(urlstr)) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter valid Site URL"
                });
                // alert("Please enter valid Site URL");
            }
            else {
                if (IsURLExists == false && IsSiteNameExist == false) {
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    let UpdateDataBO = {
                        ChangedSiteName: GridArray[index].EditSiteName,
                        ChangedSiteURL: GridArray[index].EditSiteURL,
                        ExistingSiteName: GridArray[index].SITE_DESC,
                        ExistingSiteURL: GridArray[index].SITE_URL,
                        IsEditClicked: true,
                        IsEditSiteName: this.state.IsEditSiteName,
                        IsEditSiteURL: this.state.IsEditSiteURL,

                    }
                    RefLinkMaintenanceAction.UpdateChanges(UpdateDataBO);
                } else {
                    if (IsURLExists) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Reference site already exists"
                        });
                    }
                    else if (IsSiteNameExist) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Reference site name already exists"
                        });
                    }
                    else {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Reference site and name are already exists"
                        });
                    }
                }

            }

        }



    }
    handleFavorite = (event) => {
        
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Reference Site Maintenance",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            RefLinkMaintenanceAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            RefLinkMaintenanceAction.deleteFavPage(deleteFavPageBO)
        }
    };
    loadFavPageResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let favPageResponse = JSON.parse(RefLinkMaintenanceStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (RefLinkMaintenanceStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(RefLinkMaintenanceStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(RefLinkMaintenanceStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    };

    /***
         * REFLINK_PC_27 - DHAMOTHARAN P
         * */
    SortClick = (event, sortBy, columnName) => {
        
        let MatGrid = this.state.GridArray;
        if (sortBy == "ASC") {

            MatGrid.sort(function (a, b) {
                var textA = a.SITE_DESC.toUpperCase();
                var textB = b.SITE_DESC.toUpperCase();
                return (textA > textB) ? 1 : -1;
            });



        }
        else {

            MatGrid.sort(function (a, b) {
                var textA = a.SITE_DESC.toUpperCase();
                var textB = b.SITE_DESC.toUpperCase();
                return (textA > textB) ? -1 : 1;
            });


        }
        this.setState({ GridArray: MatGrid });
    }
    /***
     * REFLINK_PC_11 - PAVITHRA R , DHAMOTHARAN P
     * */

    BindGridData = () => {
        
        if (this.state.GridArray.length > 0) {
            return this.state.GridArray.map((value, index) => {
                let siteUrlabel = value.SITE_URL;
                if (siteUrlabel.length > 50) {
                    siteUrlabel = siteUrlabel.substring(0, 44) + "...";
                }

                if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {
                    return (<React.Fragment key={index}> {value.IsEditClicked == false ? <>
                        <tr>
                            <td>{value.BUSINESS_UNIT}</td>
                            <td>{value.SITE_DESC}</td>
                            <td ><div><a href={value.SITE_URL} target="_blank" >{siteUrlabel}</a></div></td>
                            <td className="px-0" ><span onClick={(e) => this.onEditClick(e, index)}><img className="px-1" src="Images/edit-icon.png" alt="Edit" title="Edit" style={{ height: '17px' }} /></span>
                                <img className="px-1" src="Images/delete-icon.svg" alt="Delete" onClick={(e) => this.onDeleteClick(e, index)} title="Delete" style={{ height: '17px' }} /></td>

                        </tr>
                    </> : <>
                            <tr>
                                <td>{value.BUSINESS_UNIT}</td>
                                <td >
                                    <input type="text" className="form-control" name="EditSiteName" value={value.EditSiteName} onChange={e => this.OnHandleEditChange(e, "EditSiteName", index)} />
                                </td>
                                <td >
                                    <input type="text" className="form-control" name="EditSiteURL" value={value.EditSiteURL} onChange={e => this.OnHandleEditChange(e, "EditSiteURL", index)} />
                                </td>
                                <td className="px-0" ><span onClick={(e) => this.OnSaveClick(e, index)}><img className="px-1" src="Images/tick.png" alt="Save" title="Save" style={{ "height": '17px', "borderBottom": "0px solid" }} /></span>

                                    <span onClick={(e) => this.onCancelClick(e, index)}><img src="Images/cancel-icon.svg" alt="Cancel" title="Cancel" style={{ "height": '17px', "borderBottom": "0px solid" }} /></span></td>

                            </tr>
                        </>

                    }
                    </React.Fragment>
                    );
                }
            }

            )
        }

    }
    render() {
        return (
            <div className="container-fluid container-margin content-section">
                <div className="row">
                    <div className="col-md-12 page-heading mb-3">
                        <h5 className="page-title">Reference Site Maintenance</h5>
                        <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                        <label htmlFor="checkbox-OrdStatus">
                            <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                    </g>
                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                    </g>
                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                    </g>
                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                    </g>
                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                    </g>
                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                    </g>
                                    <g className="grp1" opacity={0} transform="translate(24)">
                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                    </g>
                                </g>
                            </svg>
                        </label>
                    </div>
                    <div className="col-md-12 col-sm-auto col-auto my-3 text-right ">
                        <button className="btn btn-primary custom-btn-primary primary-btn" onClick={(e) => this.OnNewURLClick(e)} >Add New Reference Link</button>
                    </div>
                    <div className="col-md-12 mb-3">
                        <div className="table-responsive">
                            <table class="table ZEUS_Grid FOM-grid" id="table"> {/*mobileflex-grid - class removed*/}
                                <thead>
                                    <tr>
                                        <th className="d-md-table-cell position-sort-icon">BusinessUnit</th>
                                        <th className="d-md-table-cell position-sort-icon">Site Name  <span className="sort-up ml-1" style={{ "top": "3px" }}><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "SITE_DESC")} /></span><span className="sort-down ml-1" ><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "SITE_DESC")} /></span></th>
                                        <th className="d-md-table-cell position-sort-icon " >URL</th>
                                        <th className="d-md-table-cell position-sort-icon">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.IsNewLink ? <tr>
                                        <td>
                                            <label> I0W01 </label>
                                        </td>
                                        <td >
                                            {/* Regression bug 5296 - Yuvarani K */}
                                            <input type="text" className="form-control" placeholder="Enter Value" maxLength="70" name="NewSiteName" value={this.state.NewSiteName} onChange={e => this.OnHandleNewChange(e, "2")} />
                                        </td>
                                        <td >
                                            {/* Regression bug 5296 - Yuvarani K */}
                                            <input type="text" className="form-control" placeholder="Enter Value" maxLength="2050" name="NewSiteURL" value={this.state.NewSiteURL} onChange={e => this.OnHandleNewChange(e, "3")} />
                                        </td>
                                        <td className="px-0"><span onClick={(e) => this.OnInsertClick(e)}><img className="px-1" src="Images/tick.png" alt="Save" title="Save" style={{ "height": '17px', "borderBottom": "0px solid" }} /></span>

                                            <span onClick={(e) => this.onNewCancelClick(e)}><img src="Images/cancel-icon.svg" alt="Cancel" title="Cancel" style={{ "height": '17px' }} /></span></td>



                                    </tr> : null}


                                    {this.state.GridArray.length > 0 ? this.BindGridData() : null}


                                </tbody>
                            </table>
                        </div>
                    </div>
                    {this.state.GridArray.length > 0 ?
                        <div className="col-md-12 mb-5">
                            <span className="total-records mt-2">
                                <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.GridArray.length}</span>
                            </span>
                            {this.state.GridArray.length > 10 ? <ReactPaginate
                                previousLabel={<span className="right-pagination-arrow" />}
                                nextLabel={<span className="left-pagination-arrow" />}
                                previousClassName={'page-item'}
                                nextClassName={'page-item'}
                                previousLinkClassName={'page-link'}
                                nextLinkClassName={'page-link'}
                                disabledClassName={'disabled'}
                                breakLabel={'...'}
                                breakClassName={'page-item'}
                                breakLinkClassName={'page-link'}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={2}
                                onPageChange={this.handlePageClick}
                                containerClassName={'custom-pagination pagination float-right'}
                                pageClassName={'page-item'}
                                pageLinkClassName={'page-link'}
                                activeClassName={'active'}
                                hrefBuilder={() => '#'}
                                forcePage={this.state.pageNo - 1}
                            /> : null}

                        </div> : <section className="site-undercontruction container text-center center-panel pt-4">
                            <div className="img-section">
                                <img src="images/nosearch.jpg" alt="imagefile" />
                            </div>
                            <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                            </p>
                        </section>}
                </div>


            </div>
        );
    };


};
export default withTranslation()(RefSiteMaintenanceComponent);
